class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Adds and/or removes paging group users and devices.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/paging-only-groups/{pagingOnlyGroupId}/bulk-assign
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: Groups
     */
    async post(editPagingGroupRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), editPagingGroupRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
